import { Component, Inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from 'src/app/shareModule/services/modal.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-compare-product-list',
  templateUrl: './compare-product-list.component.html',
  styleUrl: './compare-product-list.component.scss'
})
export class CompareProductListComponent implements OnInit, OnChanges{
  
  //This just stores the image locations for the image that is shown as main image
  public showImageLocation = [];

  @Input()
  productsToCompare: any[];

  public  verifiedTagRating(pd){
    const rawCount = pd?.verifiedTagRating;
    if(rawCount){
      if(rawCount >= 100){
        return 3;
      }
      if(rawCount >= 10){
        return 2
      }

    }
    return 1

  }


  @Input()
  productBottomDiscussExperienceTabSettings = []


  public specialTags = new Set(['Preferred', 'Top Seller', 'Freelance', 'Chain']);
  

  onImgError(event) {
    event.target.src = '../../../assets/images/shop/default.png';
  }

  private _sortProductsByValues(){
    this.productsToCompare?.sort( (p1, p2)=> (this._getProductScore(p2) - this._getProductScore(p1)) )
    console.log("Scores are:", Array.from(this.productsToCompare.map(p => this._getProductScore(p))))

  }

  private _getBadgeCount(productData): number{
    if(!productData){
      return 0;
    }

    let sellerInfo = productData['seller_info'];

    if(!sellerInfo){
      return 0
    }

    let rv = 0
    if(productData?.isPopuplarInSubRegion){
      rv ++;
    }

    const fields = ['googleReviewRating', 'fbReviewRating', 'carousellReviewRating', 
    'superDealRating', 'bestPriceRating', 'highQualityRating']
    if(typeof sellerInfo == 'string'){
      sellerInfo = JSON.parse(sellerInfo)
    }

    for(const field of fields){
      if(sellerInfo[field]){
        rv ++ ;
      }
    }
    return rv;
  }

  private _getProductScore(productData) : number{
    
    return   Math.min(3, productData?.productMoreServices?.length ?? 0)  +
             Math.min(3, productData?.productVerficationsList?.length ?? 0) +
             Math.min(3, productData?.xpCount ?? 0) +
             Math.min(3, this._getBadgeCount(productData) ?? 0) 
  }       

  
  public imgUrl = environment.ImageUrl;
  constructor(protected modalService: NgbModal, private activeModal: NgbActiveModal,   @Inject('WINDOW') private window: any,){}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['productsToCompare']){
      this.showImageLocation = []
      this._resetIsMainImage();
      this._sortProductsByValues()
      
      for(const prod of this.productsToCompare){
        this.showImageLocation.push(prod.food_image_1);
      }
    }
  }

  private _resetIsMainImage(){
    this.isMainImageselectedForProduct = new Array(this.productsToCompare.length);
    this.isMainImageselectedForProduct.fill(true);
  }
  ngOnInit(){
    this._resetIsMainImage();
    this._sortProductsByValues();
  }

  //from top image list
  public isMainImageselectedForProduct = [true, true, true, true, true];

  //used to change main image for product
  public changeShowImageProduct(i, img, pos){
    this.showImageLocation[i] = img;
    this.isMainImageselectedForProduct[i] = (pos === 0)
  }

  openCorrectedSite(url: string) {
    ////console.log({url})
    if (url?.trim()) {
      Swal.fire({
        title: "Open link",
        text: 'Open link a in a new tab?',
        icon: 'info',
        showCancelButton: true,
      }).then(res => {
        if (res.isConfirmed) {
          this.window.open(this.correctSite(url), '_blank')
        } else {

        }
      })
    }

  }
  public correctSite(site: string) {
    if (site.trim()) {
      if (site?.startsWith('https') || site?.startsWith('http')) {
        return site
      }
      if (site?.startsWith('www')) {
        return 'https://' + site
      }
      return 'https://www.' + site

    }
    return ""

  }



  public closeModals(){
    this.activeModal.dismiss();
  }
  public regionSplit(name: string): string {
    if (name && name.includes(",")) {
      let data = name.split(",");
      return `${data[0]}, ${data[1].trim().charAt(0)}`;
    } else {
      return name;
    }
  }
  public ratingsCarouselOptions: any = {
    slidesPerView: 2,
    // navigation: false, //arrows are malfunctioning
    //pagination: true 
  }




  public compareProductCarouselOptions: any = {
    slidesPerView: 1,
    spaceBetween: 3,
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      767:{
        slidesPerView: 2,
      },
      968: {
        slidesPerView: 4,
      },
    },
  };

}
